import { render } from "./BaseOTP.vue?vue&type=template&id=e3c6af2c&scoped=true"
import script from "./BaseOTP.vue?vue&type=script&lang=js"
export * from "./BaseOTP.vue?vue&type=script&lang=js"

import "./BaseOTP.vue?vue&type=style&index=0&id=e3c6af2c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c6af2c"]])

export default __exports__